import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import InStoreData from "@/pages/InStoreData";
import ComingSoon from "@/pages/ComingSoon";
import Shelfmasters from "@/pages/Shelfmasters";
import Merchandising from "@/pages/Merchandising";
import About from "@/pages/About";
import Kontakt from "@/pages/Kontakt";
import Pos from "@/pages/Pos";
import RetailConsulting from "@/pages/RetailConsulting";
import RetailDigitalisation from "@/pages/RetailDigitalisation";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

function Shell() {
  return (
    <>
      <ScrollManager />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/instore-data" element={<InStoreData />} />
          <Route path="/merchandising-services" element={<Merchandising />} />
          <Route path="/shelfmasters" element={<Shelfmasters />} />
          <Route path="/retail-digitalisation" element={<RetailDigitalisation />} />
          <Route path="/retail-consulting" element={<RetailConsulting />} />
          <Route path="/pos" element={<Pos />} />
          <Route path="/about" element={<About />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="*" element={<ComingSoon titleKey="instore" />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LanguageProvider>
          <BrowserRouter>
            <Shell />
            <Toaster position="bottom-right" closeButton richColors />
          </BrowserRouter>
        </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
